module.exports = __webpack_public_path__ + "img/portfolio-03.2559d57a.jpg";